import React from 'react'

import { Button, ButtonProps } from 'ui/components/Button'

import { useConfirmDeleteTableModal } from './useConfirmDeleteTableModal'

type DeleteNativeTableButtonProps = {
    object: ObjectDto
    // if this table is a copy of a shared table, then deletion is allowed but the wording is different
    isSharedTableCopy: boolean
} & ButtonProps

export const DeleteNativeTableButton: React.FC<DeleteNativeTableButtonProps> = ({
    object,
    isSharedTableCopy,
    ...buttonProps
}) => {
    const { showModal, canDelete } = useConfirmDeleteTableModal(object)

    if (!canDelete) {
        return null
    }

    return (
        <div>
            <Button
                startIcon={{ name: isSharedTableCopy ? 'XCircle' : 'Trash' }}
                onClick={showModal}
                size="s"
                {...buttonProps}
            >
                {isSharedTableCopy ? 'Remove table' : 'Delete this table'}
            </Button>
        </div>
    )
}
